import React from 'react';
import { CONTENT_BASE } from '@amzn/ring-common-style-library/lib/colors';

export const UnmuteIcon: React.FC<{}> = () => (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' height='100%' width='100%' fill='none'>
        <g id='speaker_off (e9a1)'>
            <g id='^ Name above ^'>
                <path
                    d='M3 15.4999H7.7L6.7 16.4999H2.5C2.2 16.4999 2 16.2999 2 15.9999V7.99992C2 7.69992 2.2 7.49992 2.5 7.49992H7.8L13.2 2.59992C13.3 2.49992 13.5 2.39992 13.7 2.49992C13.9 2.59992 14 2.79992 14 2.99992V9.09992L13 10.0999V4.09992L8.3 8.39992C8.2 8.49992 8.1 8.49992 8 8.49992H3V15.4999Z'
                    fill={CONTENT_BASE}
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M21.1 4.9L19.4 6.6C21 7.9 22 9.8 22 12C22 15.9 18.9 19 15 19V18C18.3 18 21 15.3 21 12C21 10.1 20.1 8.4 18.6 7.3L16.8 9.1C17.8 9.7 18.4 10.8 18.4 12C18.4 13.9 16.8 15.5 14.9 15.5V14.5C16.3 14.5 17.4 13.4 17.4 12C17.4 11 16.9 10.2 16.1 9.8L13.9 12V21C13.9 21.2 13.8 21.4 13.6 21.5H13.4C13.3 21.5 13.2 21.5 13.1 21.4L8.6 17.3L4.8 21.1C4.6 21.3 4.3 21.3 4.1 21.1C3.9 20.9 3.9 20.6 4.1 20.4L20.4 4.2C20.6 4 20.9 4 21.1 4.2C21.3 4.4 21.3 4.7 21.1 4.9ZM13 19.9L9.4 16.6L13 13V19.9Z'
                    fill={CONTENT_BASE}
                />
                <path
                    d='M15 5C15.9 5 16.8 5.2 17.6 5.5L16.8 6.3C16.3 6.1 15.6 6 15 6V5Z'
                    fill={CONTENT_BASE}
                />
            </g>
        </g>
    </svg>
);
